import './App.css';
import TopComponent from './components/topComponent/TopComponent';
import Home from './pages/Home/Home';
import Resume from './pages/resume/Resume';
function App() {
  return (
    <div className="App">
      {/* <TopComponent/> */}
      <Home/>
      {/* <Resume/> */}
    </div>
  );
}

export default App;
